import gql from 'graphql-tag'

export const UNSUBSCRIBE_DIGEST = gql`
  mutation UnsubscribeDigest($input: UnsubscribeDigestInput!) {
    unsubscribeDigest(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      unsubscribeDigest {
        message
      }
    }
  }
`
